import React from 'react';
import { apiGet, apiPost } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { registrySearchActions, REGISTRY } from '../../../store/ceeSearchStore';
import { Translate, withLocalize } from "react-localize-redux";
import CeeReportDateInformation from './ceeReportDateInformation';
import Message from '../../common/message';
import Money from '../../common/moneyComponent';
import NoDataComponent from '../../common/noDataComponent';
import ResponsiveTable from "../../layoutItems/responsiveTable";
import Section from '../../common/section';

class CeeCause extends React.Component {
    state = {
        country: this.props.match.url.indexOf(REGISTRY.cee) > 0 ? "CZ" : "SK",
        fragment: this.props.match.url.indexOf(REGISTRY.cee) > 0 ? REGISTRY.cee : REGISTRY.cre,
        isLoading: true,
        data: {},
        errorMessage: null
    };

    componentDidMount() {
        this.getData();
    }

    render() {
        if (this.state.isLoading)
            return <Circles />;

        if (!isNullOrUndefined(this.state.errorMessage))
            return <Message type="error" message={this.props.translate(this.state.errorMessage)} style={{ marginTop: "1em" }} />;

        if (isNullOrUndefined(this.state.data))
            return <NoDataComponent />;

        return (this.state.country === "CZ" ? this.renderCzech() : this.renderSlovak());
    }

    renderSlovak() {
        return (
            <>
                <CeeReportDateInformation inserted={this.state.data.cause.requestInsertedFormated} completed={this.state.data.cause.requestCompletedFormated} />
                <Section
                    isSection={true}
                    removeDataLevel={true}
                    bodyStyle={{ border: "none" }}
                    style={{ border: "none" }}
                    headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                    isOpen={true}
                    fontAwesomeIconName="file-alt"
                    name={this.props.translate("Search.Cee.Cause.Detail")}
                >
                    <table className="table table-report-section key-value">
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.DateIssued" />:</td>
                                <td>{this.state.data.cause.issuedFormated} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.CourtName" />:</td>
                                <td>{this.state.data.cause.court} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.CourtFileNo" />:</td>
                                <td>{this.state.data.cause.fileNo} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.Bailiff" />:</td>
                                <td>{this.state.data.cause.bailiff} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.FileNo" />:</td>
                                <td>{this.state.data.cause.exNum} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.Amount" />:</td>
                                <td><Money value={this.state.data.cause.oneTimePrice} fractionDigits={2} /> {this.state.data.cause.currency} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.Description" />:</td>
                                <td>{this.state.data.cause.desc} </td>
                            </tr>
                        </tbody>
                    </table>
                    {this.renderAmounts(this.state.data.cause.initialValues, this.state.data.cause.actualValues, this.state.data.cause.currency)}
                </Section>
                {this.renderSubjects(this.state.data.ceeSubjects, "Search.Cee.Cause.Beneficiaries")}
                {this.renderSubjects(this.state.data.subjects, "Search.Cee.Cause.SubHeader.Subjects")}
                <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray"><Translate id="Report.DisclaimerSk" options={{ renderInnerHtml: true }} /></div>
                </div>
            </>
        );
    }

    renderAmounts(initial, actual, currency = "EUR") {
        return (
            <table className="table table-report-section">
                <thead>
                    <tr>
                        <th></th>
                        <th><Translate id="Search.Cee.Cause.ClaimInitial" /></th>
                        <th><Translate id="Search.Cee.Cause.ClaimCurrent" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.Principal" />:</td>
                        <td><Money value={initial.principalAmount} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.principalAmount} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.Interest" />:</td>
                        <td><Money value={initial.interest} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.interest} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.DefaultInterest" />:</td>
                        <td><Money value={initial.interestOnDelay} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.interestOnDelay} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.DefaultFee" />:</td>
                        <td><Money value={initial.feeForDelay} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.feeForDelay} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.Penalty" />:</td>
                        <td><Money value={initial.contractualPenalty} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.contractualPenalty} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.CostsEnforcement" />:</td>
                        <td><Money value={initial.costsOfPenalty} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.costsOfPenalty} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.CostsProceedings" />:</td>
                        <td><Money value={initial.costsOfProceedings} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.costsOfProceedings} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.CostsBeneficiary" />:</td>
                        <td><Money value={initial.costsOfEntitled} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.costsOfEntitled} fractionDigits={2} /> {currency}</td>
                    </tr>
                    <tr>
                        <td><Translate id="Search.Cee.Cause.CostsBailiff" />:</td>
                        <td><Money value={initial.costsOfExecutor} fractionDigits={2} /> {currency}</td>
                        <td><Money value={actual.costsOfExecutor} fractionDigits={2} /> {currency}</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    renderCzech() {
        return (
            <>
                <CeeReportDateInformation inserted={this.state.data.cause.requestInsertedFormated} completed={this.state.data.cause.requestCompletedFormated} />
                <Section
                    isSection={true}
                    removeDataLevel={true}
                    bodyStyle={{ border: "none" }}
                    style={{ border: "none" }}
                    headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                    isOpen={true}
                    fontAwesomeIconName="file-alt"
                    name={this.props.translate("Search.Cee.Cause.Detail")}
                >
                    <table className="table table-report-section key-value">
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.ResolutionDateIssued" />:</td>
                                <td>{this.state.data.cause.issuedFormated} </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.StartDate" /></td>
                                <td>{this.state.data.cause.startDateFormated}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.InsertDate" /></td>
                                <td>{this.state.data.cause.insertDateFormated}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.WriteDate" /></td>
                                <td>{this.state.data.cause.writeDateFormated}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.Bailiff.CEE" /></td>
                                <td>{this.state.data.cause.bailiffOffice}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.FileNo.CEE" /></td>
                                <td>{this.state.data.cause.exNum}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.OneTimePrice" /></td>
                                <td><Money value={this.state.data.cause.oneTimePrice} fractionDigits={2} /></td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.RegularPrice" /></td>
                                <td><Money value={this.state.data.cause.regPrice} fractionDigits={2} /> </td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.MonetaryDescription" /></td>
                                <td>{this.state.data.cause.monetaryDesc}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.NonMonetaryDescription" /></td>
                                <td>{this.state.data.cause.nonMonetaryDesc}</td>
                            </tr>
                            <tr>
                                <td><Translate id="Search.Cee.Cause.CurrentPrice" />&nbsp;{this.state.data.cause.currentPriceDateFormatted}</td>
                                <td><Money value={this.state.data.cause.currentPriceValue} fractionDigits={2} /></td>
                            </tr>
                        </tbody>
                    </table>
                </Section>
                {this.renderSubjects(this.state.data.subjects, "Search.Cee.Cause.SubHeader.Subjects.CEE", true)}
                {this.renderDocuments(this.state.data.docs)}
                {this.renderEnforcements(this.state.data.enforcements)}
                <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray"><Translate id="Report.DisclaimerCz" options={{ renderInnerHtml: true }} /></div>
                </div>
            </>
        );
    }

    renderEnforcements(enforcements) {
        return (
            <>
                {enforcements.length > 0 && <>
                    <Section
                        isSection={true}
                        removeDataLevel={true}
                        bodyStyle={{ border: "none" }}
                        style={{ border: "none" }}
                        headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                        isOpen={true}
                        fontAwesomeIconName="paste"
                        name={this.props.translate("Search.Cee.Cause.SubHeader.Enforcements")}
                    >
                        <ResponsiveTable>
                            <table className="table table-report-section-3">
                                <thead>
                                    <tr>
                                        <th><Translate id="Search.Cee.Enforcement.Type" /></th>
                                        <th><Translate id="Search.Cee.Enforcement.Issuer" /></th>
                                        <th><Translate id="Search.Cee.Enforcement.Issued" /></th>
                                        <th><Translate id="Search.Cee.Enforcement.Inserted" /></th>
                                        <th><Translate id="Search.Cee.Enforcement.Modified" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {enforcements.map((e, i) => <tr key={i}>
                                        <td data-label={this.props.translate('Search.Cee.Enforcement.Type')}>{e.enfType}</td>
                                        <td data-label={this.props.translate('Search.Cee.Enforcement.Issuer')}>{e.issuer}</td>
                                        <td data-label={this.props.translate('Search.Cee.Enforcement.Issued')}>{e.issuedFormatted}</td>
                                        <td data-label={this.props.translate('Search.Cee.Enforcement.Inserted')}>{e.insertedFormatted}</td>
                                        <td data-label={this.props.translate('Search.Cee.Enforcement.Modified')}>{e.modifiedFormatted}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </Section>
                </>}
            </>
        );
    }

    renderDocuments(docs) {
        return (
            <>
                {docs.length > 0 && <>
                    <Section
                        isSection={true}
                        removeDataLevel={true}
                        bodyStyle={{ border: "none" }}
                        style={{ border: "none" }}
                        headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                        isOpen={true}
                        fontAwesomeIconName="paste"
                        name={this.props.translate("Search.Cee.Cause.SubHeader.Documents")}
                    >
                        <ResponsiveTable>
                            <table className="table table-report-section-3">
                                <thead>
                                    <tr>
                                        <th><Translate id="Search.Cee.Document.Type" /></th>
                                        <th><Translate id="Search.Cee.Document.CourtName" /></th>
                                        <th><Translate id="Search.Cee.Document.CourtFileNo" /></th>
                                        <th><Translate id="Search.Cee.Document.Created" /></th>
                                        <th><Translate id="Search.Cee.Document.Inserted" /></th>
                                        <th><Translate id="Search.Cee.Document.Modified" /></th>
                                        <th><Translate id="Search.Cee.Document.Text" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docs.map((d, i) => <tr key={i}>
                                        <td data-label={this.props.translate('Search.Cee.Document.Type')}>{d.docType}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.CourtName')}>{d.court}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.CourtFileNo')}>{d.fileNo}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.Created')}>{d.createdFormated}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.Inserted')}>{d.insertedFormated}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.Modified')}>{d.modifiedFormated}</td>
                                        <td data-label={this.props.translate('Search.Cee.Document.Text')}>{d.text}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </Section>
                </>}
            </>
        );
    }

    renderSubjects = (subs, header, isCzech = false) => {
        return (
            <>
                {subs.length > 0 && <>
                    <Section
                        isSection={true}
                        removeDataLevel={true}
                        bodyStyle={{ border: "none" }}
                        style={{ border: "none" }}
                        headerStyle={{ marginLeft: "0", border: "none", cursor: "default" }}
                        isOpen={true}
                        fontAwesomeIconName="users"
                        name={this.props.translate(header)}
                    >
                        <ResponsiveTable>
                            <table className="table table-report-section-3">
                                <thead>
                                    <tr>
                                        <th><Translate id="Search.Cee.Type" /></th>
                                        <th><Translate id="Search.Cee.Name" /></th>
                                        <th><Translate id="Search.Common.BirthDate" /></th>
                                        <th><Translate id="Report.PublicContracts.Ico" /></th>
                                        <th><Translate id="Search.Cee.Address" /></th>
                                        {isCzech && <th><span title={this.props.translate('Search.Cee.ExecutionOrder.Description')}><Translate id="Search.Cee.ExecutionOrder" /></span></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {subs.map((s, i) => <tr key={i}>
                                        <td data-label={this.props.translate('Search.Cee.Type')}>
                                            {s.subjectType === 1 && <Translate id="Search.Cee.Type.Company" />}
                                            {s.subjectType === 2 && <Translate id="Search.Cee.Type.Person" />}
                                            {s.subjectType === 3 && <Translate id="Search.Cee.Type.SoleTrader" />}
                                        </td>
                                        <td data-label={this.props.translate('Search.Cee.Type')}>{s.subjectType === 1 ? s.companyName : s.displayName}</td>
                                        <td data-label={this.props.translate('Search.Common.BirthDate')}>{s.birthDateFormated}</td>
                                        <td data-label={this.props.translate('Report.PublicContracts.Ico')}>{s.companyId}</td>
                                        <td data-label={this.props.translate('Search.Cee.Address')}>{s.address}</td>
                                        {isCzech && <td data-label={this.props.translate('Search.Cee.ExecutionOrder')}>{s.executionOrder === true ? <Translate id="Common.Yes" /> : (s.executionOrder === false ? <Translate id="Common.No" /> : "")}</td>}
                                    </tr>)}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </Section>
                </>}
            </>
        );
    }

    toggleSection = (i) => {
        const expanded = this.state.expanded;
        expanded[i] = !expanded[i];
        this.setState({ expanded: expanded });
    }

    getData = () => {
        this.setState({ isLoading: true });
        this.props.setResultsRequestParams(this.state.fragment, null);

        apiGet(this.getBaseUrl(this.props.match.params.id),
            { country: this.state.country },
            (data) => {
                if (!isNullOrUndefined(data.data)) {
                    this.dataLoaded(data.data)
                } else {
                    this.onError(data.error)
                }
            },
            () => this.onError()
        );
    }

    dataLoaded = (data) => {
        this.setState({ isLoading: false, data: data });

        if (!data.isCustomerResult) {
            apiPost(this.getBaseUrl(this.props.match.params.id) + '/mark-as-seen', { country: this.state.country }, null,
                () => this.setState({ data: data, isLoading: false }),
                () => this.onError()
            );
        } else {
            this.setState({ data: data, isLoading: false });
        }

        if (!isNullOrUndefined(data)) {
            this.props.setResultsRequestParams(this.state.fragment, { subPath: 'cause', id: parseInt(this.props.match.params.id), params: { country: this.state.country } });
        }
    }

    onError = (error) => this.setState({ isLoading: false, errorMessage: error && error.message });
    getBaseUrl = (id) => `${window.babylonApiUrl}/api/search/cee/cause/${id}`;
}

export default withLocalize(connect(
    state => state.registrySearch,
    dispatch => bindActionCreators({ ...registrySearchActions }, dispatch)
)(CeeCause));